import { Component, Input } from '@angular/core';
import { FixedPriceProjectTimerecord } from '../../../core/services/fixed-price-projects.service';
import { BaseModalComponent } from './base-modal.component';

export interface FixedPriceProjectTimerecordsModalConfig {
  title: string;
  rows: FixedPriceProjectTimerecord[];
}

@Component({
  selector: 'app-fixed-price-project-timerecords-modal',
  template: require('./fixed-price-project-timerecords-modal.component.html').default,
  styles: [
    require('!!raw-loader!sass-loader!./base-modal.component.scss').default,
    require('!!raw-loader!sass-loader!./fixed-price-project-timerecords-modal.component.scss').default,
  ],
  animations: [BaseModalComponent.modalAnimations[0]],
  standalone: false,
})
export class FixedPriceProjectTimerecordsModalComponent extends BaseModalComponent {
  @Input() title = 'Tidrapport';
  @Input() rows: FixedPriceProjectTimerecord[] = [];

  configure(config?: FixedPriceProjectTimerecordsModalConfig): void {
    this.title = config?.title || this.title;
    this.rows = config?.rows || [];
  }
}
